import * as types from "../../constants/misc/settings_constant";

const initialState = {
  data: null,
  dataError: null,
  message: null,
  genre: null,
};

const manualReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_MANUAL_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case types.ADD_MANUAL_AUTHORIZATION_FAILURE:
      return {
        ...state,
        dataError: action.payload,
      };
    case types.GET_MANUAL_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        data: action.payload.manual,
        genre: action.payload.genre,
      };
    case types.GET_MANUAL_AUTHORIZATION_FAILURE:
      return {
        ...state,
        dataError: action.payload,
      };
    case types.DELETE_MANUAL_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case types.DELETE_MANUAL_AUTHORIZATION_FAILURE:
      return {
        ...state,
        dataError: action.payload,
      };
    default:
      return state;
  }
};

export default manualReducer;
